<template>
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 780.000000 780.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,855.000000) scale(0.10000,-0.110000)"
        fill="#000000"
        stroke="none"
      >
      <path d="M2711 7038 c-17 -5 -87 -46 -154 -92 -382 -259 -1844 -1247 -2139
-1445 -191 -128 -354 -244 -363 -258 -45 -68 -19 -175 50 -207 47 -23 83 -16
158 29 32 19 60 35 63 35 2 0 4 -651 4 -1446 0 -1296 2 -1449 16 -1479 33 -69
-70 -65 1482 -65 l1400 0 46 137 46 136 -595 -6 -595 -6 0 577 0 577 625 4
625 4 2 -489 c2 -300 6 -481 12 -469 5 11 31 70 59 130 68 153 113 270 147
390 30 101 30 104 30 357 0 243 -1 257 -21 282 -11 14 -29 31 -40 36 -13 7
-284 11 -815 10 -726 0 -799 -2 -825 -17 -15 -9 -32 -28 -38 -42 -9 -24 -21
-675 -21 -1143 l0 -208 -645 0 -645 0 0 1454 0 1455 442 297 c244 164 565 379
713 479 149 100 438 296 644 434 l374 251 451 -302 c813 -544 1390 -931 1476
-990 46 -32 89 -58 95 -58 6 0 60 29 121 65 145 86 141 83 128 92 -13 11 -995
670 -1679 1128 -332 223 -552 364 -571 367 -16 2 -45 0 -63 -4z"/>
<path d="M2602 5634 c-21 -15 -22 -21 -22 -193 0 -124 -4 -181 -12 -189 -8 -8
-63 -12 -179 -12 -210 0 -199 9 -199 -170 0 -93 4 -131 14 -146 13 -17 31 -19
193 -24 l178 -5 5 -183 c6 -231 -1 -222 167 -222 83 0 122 4 143 15 17 9 31
17 32 18 1 1 4 85 7 187 l6 185 170 5 c164 6 202 11 217 34 4 6 8 68 8 139 0
175 10 167 -208 167 -117 0 -172 4 -180 12 -8 8 -12 64 -12 185 0 224 9 213
-173 213 -104 0 -137 -3 -155 -16z"/>
<path d="M5255 5391 c-338 -167 -503 -279 -680 -463 -211 -216 -312 -433 -345
-738 -13 -114 -13 -115 -91 -265 -136 -262 -184 -388 -294 -777 -72 -251 -117
-383 -163 -473 -86 -171 -401 -1067 -383 -1088 4 -4 31 -10 59 -14 39 -4 52
-10 52 -22 0 -22 -136 -517 -265 -966 -112 -387 -122 -444 -92 -502 54 -101
209 -109 277 -13 12 16 104 279 204 583 101 303 207 616 236 694 45 122 56
143 74 143 17 0 26 13 45 63 36 94 138 340 183 445 27 60 46 92 55 90 8 -2 85
-142 172 -313 140 -274 162 -310 183 -310 19 0 30 -14 60 -75 85 -169 182
-417 293 -745 37 -110 70 -206 74 -212 4 -7 50 108 103 256 l97 270 -49 153
c-26 84 -69 211 -94 283 -25 71 -46 137 -46 146 0 12 14 19 49 25 l49 9 -93
260 c-121 341 -206 566 -262 694 -56 129 -55 152 11 289 94 193 306 532 334
532 38 0 352 -273 352 -306 0 -33 -81 -84 -384 -245 -77 -41 -157 -90 -178
-110 -32 -30 -38 -42 -38 -78 0 -33 7 -49 33 -78 30 -32 40 -36 78 -35 102 1
487 159 644 264 134 90 185 164 185 270 -1 207 -194 404 -715 733 -113 72
-259 165 -325 207 l-120 77 0 56 c0 111 22 250 54 347 51 150 111 243 251 383
151 152 261 226 538 365 190 95 212 109 229 142 17 33 18 40 5 70 -20 47 -71
88 -110 88 -20 0 -112 -40 -252 -109z"/>
<path d="M7370 5322 c-285 -131 -495 -259 -651 -395 -155 -136 -250 -256 -325
-412 -57 -120 -82 -215 -96 -365 -11 -121 -13 -129 -63 -230 -231 -464 -527
-1253 -791 -2105 -97 -312 -331 -1043 -442 -1380 -84 -254 -93 -312 -56 -362
58 -78 145 -95 226 -44 57 36 75 68 173 291 204 465 307 691 483 1055 293 610
351 725 364 725 14 0 20 -11 133 -225 41 -77 122 -228 180 -335 213 -391 255
-495 465 -1139 99 -302 121 -346 190 -382 65 -35 148 -21 196 33 46 50 57 87
51 173 -3 44 -10 94 -16 110 -5 17 -21 80 -35 140 -94 410 -172 725 -208 840
-31 103 -72 201 -323 780 -181 417 -177 395 -92 571 32 65 82 157 110 204 81
136 250 380 262 380 39 0 345 -266 345 -300 0 -10 -17 -33 -39 -53 -41 -37
-68 -52 -341 -197 -96 -50 -189 -103 -207 -116 -72 -55 -64 -158 15 -191 34
-15 42 -14 100 0 92 24 342 122 457 180 213 106 336 204 382 303 30 67 27 93
-23 194 -28 54 -61 97 -138 174 -123 124 -257 225 -650 488 -166 111 -325 219
-355 241 l-54 40 7 91 c17 255 105 444 288 622 135 132 240 201 610 404 85 46
100 59 119 96 20 42 20 44 3 80 -20 41 -66 74 -104 74 -14 -1 -81 -26 -150
-58z"/>
<path d="M3938 4867 c-31 -13 -92 -49 -135 -79 -136 -95 -176 -112 -268 -112
-53 0 -93 6 -119 17 -22 10 -40 16 -42 14 -8 -8 29 -134 52 -172 34 -58 104
-121 167 -150 133 -62 218 -38 423 116 100 76 195 129 228 129 12 0 28 34 53
113 4 12 -7 30 -34 56 -90 85 -219 112 -325 68z"/>
<path d="M5178 4749 c-80 -11 -161 -54 -233 -121 -162 -151 -191 -367 -74
-549 42 -66 100 -116 178 -153 61 -28 74 -31 166 -30 80 0 112 5 158 23 109
43 215 150 259 261 32 82 36 217 9 291 -72 192 -263 307 -463 278z"/>
<path d="M7273 4689 c-162 -27 -298 -147 -353 -309 -17 -51 -21 -82 -18 -150
3 -75 8 -95 40 -161 65 -130 176 -214 317 -240 63 -11 81 -10 147 5 98 23 157
55 225 123 62 60 100 129 124 219 19 73 19 115 0 189 -45 172 -179 297 -346
325 -35 5 -68 9 -74 9 -5 -1 -33 -5 -62 -10z"/>
      </g>
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconIaf'
  }
  </script>
  
  <style scoped>
  </style>
  